import { env } from './env'

// VAPID public key used to create push subscriptions. It is not a secret —
// every browser receives it — so we commit it as the default and let an env
// var override it. Without this fallback, static builds without
// VITE_VAPID_PUBLIC_KEY set ship an undefined key and push subscription fails.
// Must match the server's VAPID_PUBLIC_KEY (Heroku config on buncheck-ts).
const DEFAULT_VAPID_PUBLIC_KEY =
  'BDVyqqGiJiltCstUoZiLUjxjUp88q0BEF00jGx80-6JnMbzIxfACFQkn6A_VeSrBRQAFYtiLrD2M1vqmxBK1yQ8'
const vapidKey =
  import.meta.env.VITE_VAPID_PUBLIC_KEY || DEFAULT_VAPID_PUBLIC_KEY

const hostname = window.location.hostname
const apiPort = import.meta.env.VITE_API_PORT || '3101'
let config = {
  apiEndpoint: `http://${hostname}:${apiPort}`,
  vapidKey,
}

if (env === 'production') {
  config.apiEndpoint = 'https://api.buncheck.com'
}

export { config }
